import ModalWrapper from './ModalWrapper'
Vue.component('ModalWrapper', ModalWrapper)



// WEBPACK FOOTER //
// ./src/js/components/ModalWrapper/index.js